import { apiCallCenter, apiAgi, apiClientGeral } from '@/plugins/axios'

export default {
  getData(data) {
    return apiCallCenter().post('/relatorios/filas/monitor?_method=GET', data)
  },

  acoesOperador(data) {
    return apiCallCenter().post('/agent/login', data)
  },

  spyChannel(data) {
    return apiAgi().post('/click-to-call/spy', data)
  },

  getPausas() {
    return apiCallCenter().get('/relatorios/monitor/pausas/lazy')
  },

  getRamais() {
    return apiClientGeral().get('/ramais/lazy')
  },

  getFilas() {
    return apiCallCenter().get('/relatorios/monitor/filas/lazy')
  },

  getOperadores() {
    return apiCallCenter().get('/agent/lazy')
  },
}
